import { defineAsyncComponent } from 'vue';
import { mapState as rootMapState } from 'pinia';
import { usePageStore } from '@/store'
export default {
    computed: {
        ...rootMapState(usePageStore, {
            page: store => store.page
        }),
        searchBar({ page }) {
            return page.searchCenter ? 'search-bar-center' : 'search-bar';
        }
    },
    components: {
        'search-bar': defineAsyncComponent(() => import(/* webpackChunkName: "md-hero/layout10/search-bar"*/ './search-bar')),
        'search-bar-center': defineAsyncComponent(() => import(/* webpackChunkName: "md-hero/layout10/search-bar-center"*/ './search-bar-center'))
    }
};
